<template>
  <div class="card">
    <div class="delivery">
      <div class="delivery-list" v-for="(item, index) in qualificationList" :key="index" >
        <div class="">商家名称：东北化工销售公司</div>
        <div class="">截止日期：2019-12-31</div>
        <div class="border"></div>
        <div class="delivery-list-div">
          <p>卖方确认书</p>
          <p class="p"><span>预览</span></p>
        </div>
        <div class="delivery-list-div">
          <p>买方确认书</p>
          <p class="p"><span>预览</span></p>
        </div>
      
      </div>
     
    </div>
  </div>
</template>
<script>
// import orderApi from "@/request/orderApi";
export default {
  name: "QualificationCard",
  props: {
    // order: Object,
  },
  data() {
    return {
  qualificationList: [
    {no: "京B12345", idCard: "410901198810240988",type:"牵引车",num: "100", date: "2021-1-20", status: "审核通过"},
    {no: "京B12345", idCard: "410901198810240988",type:"牵引车",num: "100", date: "2020-10-20", status: "已过期"},
    {no: "京B12345", idCard: "410901198810240988",type:"牵引车",num: "100", date: "2021-1-12", status: "待审核"},
  ]

     
    };
  },
  computed: {
    
  
  },
  methods: {
    toDetails() {
      this.$router.push("/qualificationDetails");
    }
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';
.font30 {
  font-size: 30px;
}
.delivery-list >>> .van-col {
    line-height: 50px;
}
.card {
  margin-top: 24px;
  font-size: 26px;
  .delivery {
    margin-top: 50px;
  }
  .delivery-list {
      background: #fff; 
      padding: 10px 30px;
      margin:10px 10px 0 10px;
      border-radius: 6px;
      .delivery-list-div {
         display: flex;
         justify-content: space-between;
      }
      .p {
        span{
          border: 1px solid rgba(255, 0, 0, 1);
          padding: 10px;
          border-radius: 6px;
        }    
      }
      div {
        line-height: 60px;
      }
  }

  .color-red {
    color: #E12020;
  }
  .card-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 120px;

    .btn {
      min-width: 200px;
      height: 72px;
      background: $gradientColor;
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>